module.exports = __webpack_public_path__ + "static/media/state-locked.df957b21.svg";